export const FlyoutPosition = {
  top: 0,
  right: 1,
  bottom: 2,
  left: 3,
}
